(function($) {
  var CHAR_MAX = 10;
  var SYMBOL_COST = 2;
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var sideModes = ['zeichen', 'zeichen'];
  function getSideMode(index) { return sideModes[index] || 'zeichen'; }
  var previewSideCount = 1;
  var physicalSideMap = [0];

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.ke014SetPhysicalSideMap = setPhysicalSideMap;


  /* Reglerfenster ?ke014tuner=1 — docs/TUNER-VOLLAUSBAU.md.
     Alles neutral (0/1): der Einbau veraendert kein bestehendes Bild.
     Steht bewusst auf Modulebene: innerhalb der Renderfunktion
     wuerde es bei jedem Aufbau neu entstehen und jeden gedrehten
     Wert sofort verwerfen. */
  var KE014_TUNE = {
    blockDx: 0, blockDy: 0, blockScale: 1,
    motivScale: 1
  };
  var KE014_FONT = {
    name: 'G02',
    family: 'NirmalaS, sans-serif'
  };

  var KE014_PREVIEW_IMAGES = {
    silver: window.VIV_KE014.bild_ke014_preview_silver_png,
    gold: window.VIV_KE014.bild_ke014_preview_gold_png,
    rosegold: window.VIV_KE014.bild_ke014_preview_rosegold_png,
    silverVorder: window.VIV_KE014.bild_ke014_preview_silver_vorder_png,
    goldVorder: window.VIV_KE014.bild_ke014_preview_gold_vorder_png,
    rosegoldVorder: window.VIV_KE014.bild_ke014_preview_rosegold_vorder_png
  };


  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.

     ★ Der Bestand kommt jetzt aus DIESER Datei. Frueher wurde er aus dem
     Template-Picker (.product_info_image_json, die alten C1–C50) ausgefiltert
     — das Snippet war also davon abhaengig, dass im Template noch der alte
     Picker steckt. Diese Abhaengigkeit ist damit weg.

     ⚠️ Dateinamen sind unregelmaessig: w01–w10 zweistellig, ab W11
     dreistellig (w011, w027, w031 …). Nicht "vereinheitlichen". */
  var KE014_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz',
    'w02.png': 'Herz',
    'w03.png': 'Doppelherz',
    'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch',
    'w07.png': 'Kreuz',
    'w09.png': 'Engel',
    'w027.png': 'Anker',
    'w031.png': 'Pfote',
    'w036.png': 'Fee',
    'w041.png': 'Stern'
  };

  var KE014_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',  image: window.VIV_KE014.bild_w01_png },
    { code: 'W02', text: 'Herz',       image: window.VIV_KE014.bild_w02_png },
    { code: 'W03', text: 'Doppelherz', image: window.VIV_KE014.bild_w03_png },
    { code: 'W05', text: 'Infinity',   image: window.VIV_KE014.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch', image: window.VIV_KE014.bild_w06_png },
    { code: 'W07', text: 'Kreuz',      image: window.VIV_KE014.bild_w07_png },
    { code: 'W09', text: 'Engel',      image: window.VIV_KE014.bild_w09_png },
    { code: 'W27', text: 'Anker',      image: window.VIV_KE014.bild_w027_png },
    { code: 'W31', text: 'Pfote',      image: window.VIV_KE014.bild_w031_png },
    { code: 'W36', text: 'Fee',        image: window.VIV_KE014.bild_w036_png },
    { code: 'W41', text: 'Stern',      image: window.VIV_KE014.bild_w041_png }
  ];

  /* Altwerte: KH1–KH8 aus der allerersten Generation, plus die eine echte
     Umbenennung der W-Reihe (Fisch → Jesusfisch). Ohne diesen Alias faende
     getSymbol() ein altes "Fisch" nicht mehr und das Motiv fiele im
     wiederhergestellten Warenkorb stillschweigend weg. */
  var KE014_KH_LEGACY = {
    'KH1': 'Mini Herz',
    'KH2': 'Herz',
    'KH3': 'Doppelherz',
    'KH4': 'Infinity',
    'KH5': 'Jesusfisch',
    'KH6': 'Anker',
    'KH7': 'Engel',
    'KH8': 'Pfote',
    'Fisch': 'Jesusfisch',
    'Christenfisch': 'Jesusfisch'
  };

  var ke014SymbolsCache = null;

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function normalizeKe014SymbolName(text, imageUrl) {
    var file = imageFileFromUrl(imageUrl);
    if (KE014_SYMBOL_NAMES[file]) return KE014_SYMBOL_NAMES[file];
    if (KE014_KH_LEGACY[text]) return KE014_KH_LEGACY[text];
    return text;
  }

  function normalizeKe014StoredSymbol(name) {
    if (!name) return '';
    return KE014_KH_LEGACY[name] || name;
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker.
     Damit ist die Reihenfolge garantiert (KE008-Reihenfolge) und ein
     aufgeraeumtes Template kann den Bestand nicht mehr leerlaufen lassen. */
  function loadKe014Symbols() {
    if (ke014SymbolsCache) return ke014SymbolsCache;
    ke014SymbolsCache = KE014_SYMBOLS_FIXED.slice();
    return ke014SymbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE" (z. B. "Jesusfisch | W06").
     Der Code ist der einzige Weg, wie der Auftrags-Parser das Bild findet;
     der Name steht davor, damit die Werkstatt ihn ohne Tabelle liest. */
  function formatKe014SymbolOrderValue(name) {
    var resolved = normalizeKe014StoredSymbol(name);
    if (!resolved) return '';
    var symbols = loadKe014Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Feldname ist hier kein Kosmetikthema, sondern die Bedingung dafuer, dass
     der Auftrags-Parser ueberhaupt ein Bild zeigt:
       • reines Motiv  → Label endet auf "Motiv"        → er loest den Code auf
       • Text + Motiv  → Label endet auf "Text + Motiv" → er trennt "Text(Motiv)"
         selbst auf und loest den Klammerinhalt auf
     Ein Motiv, das (wie frueher) unter dem Label "Text" mitfaehrt, wird als
     reiner Text einsortiert und bleibt fuer immer bildlos.
     `withCode` = true fuer die Bestellzeile, false fuer die Bestaetigung, die
     der Kunde sieht (dort waere "| W06" nur Rauschen). */
  function ke014OrderRow(title, engraving, withCode) {
    var text = $.trim(engraving.text || '');
    var sym = withCode
      ? formatKe014SymbolOrderValue(engraving.symbol)
      : normalizeKe014StoredSymbol(engraving.symbol);
    if (text && sym) return { name: title + ' Text + Motiv', value: text + '(' + sym + ')' };
    if (sym)         return { name: title + ' Motiv',        value: sym };
    return { name: title + ' Text', value: text };
  }

  /*
   * Preview calibration for ke014-preview-*.jpg (front left, back right in one image).
   * Positions are center points in % of the preview stage (0–100).
   * Voice tweaks: adjust top/left/width/rotate below.
   * 0–1000 scale: x = left * 10, y = top * 10
   */
  var PREVIEW_TEXT = { top: 67, left: 29 };
  var PREVIEW_TEXT_BACK = { top: 67, left: 76 };

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1 && label.indexOf('ros') === -1) return 'gold';
    return 'silver';
  }

  function ensureKe014GravurConfig() {
    if (window.ke014GravurConfig || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (config) {
      window.lwGravurConfig = config;
      window.ke014GravurConfig = config;
    }
  }

  function usesFrontOnlyPreviewBase() {
    ensureKe014GravurConfig();
    var sides = window.ke014GravurConfig && window.ke014GravurConfig.physicalSides;
    return Array.isArray(sides) && sides.length === 1 && sides[0] === 0;
  }

  function getColorPreviewUrl() {
    var colorKey = getColorKeyFromOption1();
    if (usesFrontOnlyPreviewBase()) {
      return KE014_PREVIEW_IMAGES[colorKey + 'Vorder'] || KE014_PREVIEW_IMAGES[colorKey];
    }
    return KE014_PREVIEW_IMAGES[colorKey] || KE014_PREVIEW_IMAGES.silver;
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var resolved = normalizeKe014StoredSymbol(name);
    var symbols = loadKe014Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved || symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0;
    var re = /\(([^)]+)\)/g;
    var last = 0;
    var match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += SYMBOL_COST;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;

    if (!$host.find('.ke014-preview-wrap').length) {
      $host.prepend(
        '<div class="ke014-preview-wrap">' +
          '<div class="ke014-preview-label">Vorschau</div>' +
          '<div class="ke014-preview-stage" data-ke014-preview-stage>' +
            /* NIE loading="lazy" (GOTCHAS 27): das Fenster faehrt von ausserhalb des
               Viewports herein — dort laedt der Browser ein lazy-Bild nicht, und er
               prueft es beim Hereinfahren auch nicht neu. Das Basisbild bliebe grau,
               ohne Fehler in der Konsole (complete=false, naturalWidth 0). Real
               gemessen bei KS017, A203 und A227; Bestand am 2026-09-15 bereinigt. */
            '<img class="ke014-preview-base" alt="">' +
            '<div class="ke014-preview-layers"></div>' +
          '</div>' +
        '</div>'
      );
    }
  }

  function buildEngravingHtml(raw) {
    if (!raw) return '';
    var html = '';
    var re = /\(([^)]+)\)/g;
    var last = 0;
    var match;
    while ((match = re.exec(raw)) !== null) {
      if (match.index > last) {
        html += esc(raw.substring(last, match.index));
      }
      var sym = getSymbolByName(match[1]);
      if (sym && sym.image) {
        html += '<img src="' + esc(sym.image) + '" alt="' + esc(match[1]) + '">';
      } else {
        html += esc('(' + match[1] + ')');
      }
      last = re.lastIndex;
    }
    if (last < raw.length) {
      html += esc(raw.substring(last));
    }
    return html;
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-ke014-preview-stage] .ke014-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();

    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      if (!$side.length) continue;

      var raw = $.trim(getComposedEngraving(i));
      if (!raw) continue;

      var physicalSide = getPhysicalSideIndex(i);
      var pos = physicalSide === 1 ? PREVIEW_TEXT_BACK : PREVIEW_TEXT;
      var sideClass = physicalSide === 1 ? ' ke014-preview-text--back' : ' ke014-preview-text--front';
      var style = 'top:' + (pos.top + KE014_TUNE.blockDy) + '%;left:' + (pos.left + KE014_TUNE.blockDx) + '%;font-family:' + KE014_FONT.family + ';';
      $layers.append('<div class="ke014-preview-text' + sideClass + '" style="' + style + '">' + buildEngravingHtml(raw) + '</div>');
    }
  }


  /* ---- Reglerfenster ?ke014tuner=1. Panel-Id endet auf -tuner, Griff
     traegt .kt-title: Ziehen und DE/中 kommen von den gemeinsamen Snippets. ---- */
  function ke014TunerEnabled() {
    return /ke014tuner=1/.test(window.location.search + window.location.hash);
  }

  function ke014TunerApply() {
    var b = document.querySelectorAll('[class*="preview-stage"], [class*="preview-layers"]');
    for (var i = 0; i < b.length; i++) {
      b[i].style.setProperty('--tuner-block-scale', KE014_TUNE.blockScale);
      b[i].style.setProperty('--tuner-motiv-scale', KE014_TUNE.motivScale);
    }
  }

  function ke014BuildTuner() {
    if (!ke014TunerEnabled() || document.getElementById('ke014-tuner')) return;
    var T = KE014_TUNE;
    var it = [
      { h: 'Gesamt' },
      { label: 'Gesamt: Block ↔ X %', step: 0.25, get: function() { return T.blockDx; }, set: function(v) { T.blockDx = v; } },
      { label: 'Gesamt: Block ↕ Y %', step: 0.25, get: function() { return T.blockDy; }, set: function(v) { T.blockDy = v; } },
      { label: 'Gesamt: Block-Größe ×', step: 0.02, get: function() { return T.blockScale; }, set: function(v) { T.blockScale = v; } },
      { label: 'Gesamt: Motiv-Größe ×', step: 0.02, get: function() { return T.motivScale; }, set: function(v) { T.motivScale = v; } }
    ];
    var el = document.createElement('div');
    el.id = 'ke014-tuner';
    el.style.cssText = 'position:fixed;left:10px;bottom:10px;z-index:999999;width:300px;' +
      'max-height:80vh;overflow-y:auto;background:#1f1f1f;color:#eee;padding:8px 10px;' +
      'border-radius:6px;box-shadow:0 8px 28px rgba(0,0,0,.4);font:12px/1.4 Menlo,Consolas,monospace';
    var kopf = document.createElement('div');
    kopf.className = 'kt-title';
    kopf.style.cssText = 'font-weight:700;font-size:12px;margin-bottom:6px';
    kopf.textContent = 'KE014 Tuner';
    el.appendChild(kopf);
    it.forEach(function(item) {
      if (item.h) {
        var hh = document.createElement('h5');
        hh.textContent = item.h;
        hh.style.cssText = 'margin:8px 0 3px;font-size:11px;color:#c4a574';
        el.appendChild(hh);
        return;
      }
      var row = document.createElement('div');
      row.className = 'kt-row';
      row.style.cssText = 'display:flex;align-items:center;gap:6px;margin:2px 0';
      var lab = document.createElement('label');
      lab.textContent = item.label;
      lab.title = item.label;
      lab.style.cssText = 'flex:1;font-size:11px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis';
      var inp = document.createElement('input');
      inp.type = 'number';
      inp.step = item.step;
      inp.value = item.get();
      inp.style.cssText = 'width:74px;font:11px monospace';
      // eigener Listener je Feld, sonst verliert das Tippen den Fokus
      inp.addEventListener('input', function() {
        var n = parseFloat(inp.value);
        if (!isNaN(n)) { item.set(n); window.ke014UpdatePreview(); }
      });
      row.appendChild(lab);
      row.appendChild(inp);
      el.appendChild(row);
    });
    var foot = document.createElement('div');
    foot.style.cssText = 'border-top:1px solid #444;margin-top:8px;padding-top:6px';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Alle Werte anzeigen & kopieren';
    var ta = document.createElement('textarea');
    ta.readOnly = true;
    ta.style.cssText = 'display:none;width:100%;height:130px;font:10px monospace;margin-top:4px';
    btn.addEventListener('click', function() {
      ta.style.display = 'block';
      ta.value = JSON.stringify({ TUNE: KE014_TUNE }, null, 1);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
    });
    foot.appendChild(btn);
    foot.appendChild(ta);
    el.appendChild(foot);
    document.body.appendChild(el);
  }

  window.ke014UpdatePreview = function() {
    ke014BuildTuner();
    ke014TunerApply();
    ensurePreviewShell();
    var baseUrl = getColorPreviewUrl();
    var $stage = $('[data-ke014-preview-stage]');
    $stage.find('.ke014-preview-base').attr('src', baseUrl);
    renderAllPreviewEngravings();
  };

  function parseEngravingValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match && getSymbolByName(match[1])) {
      return {
        text: val.substring(0, val.length - match[0].length),
        symbol: normalizeKe014StoredSymbol(match[1])
      };
    }
    return { text: val, symbol: '' };
  }

  function composeEngraving(text, symbol) {
    return (text || '') + (symbol ? '(' + symbol + ')' : '');
  }

  function getSideEngraving(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    var mode = $side.attr('data-ke014-mode') || 'zeichen';
    var symbol = normalizeKe014StoredSymbol($side.attr('data-ke014-symbol') || '');
    var text;

    if (mode === 'zeichen') {
      text = $input.val() || '';
    } else {
      var parsedInput = parseEngravingValue($input.val() || '');
      text = parsedInput.text;
      symbol = normalizeKe014StoredSymbol(parsedInput.symbol || symbol);
      $side.attr('data-ke014-symbol', symbol);
    }

    return { text: text, symbol: symbol };
  }

  function getComposedEngraving(sideIndex) {
    var parts = getSideEngraving(sideIndex);
    return composeEngraving(parts.text, parts.symbol);
  }

  function captureSideEngraving(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    var mode = $side.attr('data-ke014-mode') || 'zeichen';
    var text;
    var symbol = normalizeKe014StoredSymbol($side.attr('data-ke014-symbol') || '');

    if (mode === 'zeichen') {
      var parsed = parseEngravingValue($input.val() || '');
      text = parsed.text;
      symbol = normalizeKe014StoredSymbol(symbol || parsed.symbol);
    } else {
      var composed = parseEngravingValue($input.val() || '');
      text = composed.text;
      symbol = normalizeKe014StoredSymbol(symbol || composed.symbol);
    }

    $side.attr('data-ke014-symbol', symbol);
    return { text: text, symbol: symbol };
  }

  function syncSymbolGridSelection(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var selected = getSideEngraving(sideIndex).symbol;
    var $grid = $side.find('.ke014-symbol-grid');
    $grid.find('button').removeClass('is-active');
    if (selected) {
      $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
    }
  }

  function setSymbolSelection(sideIndex, symName) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    if (!$input.length || !symName) return;
    symName = normalizeKe014StoredSymbol(symName);

    var parts = captureSideEngraving(sideIndex);
    var composed = composeEngraving(parts.text, symName);
    if (weightedLength(composed) > CHAR_MAX) return;

    $side.attr('data-ke014-symbol', symName);

    $input.val(composeEngraving(parts.text, symName));

    updateCharCounter($input, sideIndex);
    syncSymbolGridSelection(sideIndex);
    window.ke014UpdatePreview();
  }

  function buildSymbolGrid(sideIndex) {
    var symbols = loadKe014Symbols();
    var selected = getSideEngraving(sideIndex).symbol;
    var html = '<div class="ke014-symbol-grid" data-side="' + sideIndex + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '" title="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="ke014-symbol-label">' + esc(sym.text) + '</span>' +
      '</button>';
    }
    html += '</div>';
    return html;
  }

  function applyFixedFont($input) {
    $input.css('font-family', KE014_FONT.family);
    $input.attr('data-font-family', KE014_FONT.name);
  }

  function updateCharCounter($input, sideIndex) {
    if (isNaN(sideIndex)) {
      sideIndex = getSideIndexFromEl($input);
    }
    var composed = isNaN(sideIndex) ? ($input.val() || '') : getComposedEngraving(sideIndex);
    var len = weightedLength(composed);
    var $words = $input.siblings('.number-header-words');
    $words.find('.number-1').text(len);
    $words.find('.wordsNum_v1').text(CHAR_MAX);
    if (composed) {
      $input.siblings('.number-header-icon').css('display', 'block');
    } else {
      $input.siblings('.number-header-icon').css('display', 'none');
    }
  }

  function setSideMode(sideIndex, mode) {
    sideModes[sideIndex] = mode;
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var parts = captureSideEngraving(sideIndex);
    $side.attr('data-ke014-mode', mode);
    $side.find('.ke014-mode-switch button').removeClass('is-active');
    $side.find('.ke014-mode-switch button[data-mode="' + mode + '"]').addClass('is-active');

    var $textareaBlock = $side.find('.p-w-plattchen-list-number-header');
    var $tabParameter = $side.find('.pattles-tab-parameter');
    var $input = $side.find('.text_class_' + sideIndex);

    $side.find('.ke014-side-error').hide();
    $side.removeClass('has-error');

    if (mode === 'zeichen') {
      $tabParameter.show();
      $textareaBlock.show();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      $side.find('.ke014-symbol-grid').hide();
      $side.attr('data-type', 'text');
      $input.val(parts.text);
      $input.prop('readonly', false);
      applyFixedFont($input);
    } else if (mode === 'symbol') {
      $tabParameter.show();
      $textareaBlock.show();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      var symbols = loadKe014Symbols();
      var $grid = $side.find('.ke014-symbol-grid');
      if (!$grid.length || $grid.find('button').length !== symbols.length) {
        $grid.remove();
        $side.find('.p-w-plattchen-list-number-header').after(buildSymbolGrid(sideIndex));
      } else {
        syncSymbolGridSelection(sideIndex);
      }
      $side.find('.ke014-symbol-grid').show();
      $side.attr('data-type', 'image');
      $input.val(composeEngraving(parts.text, parts.symbol));
      $input.prop('readonly', false);
      applyFixedFont($input);
      syncSymbolGridSelection(sideIndex);
    }

    updateCharCounter($input, sideIndex);
    window.ke014UpdatePreview();
  }

  function bindSideEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.find('.ke014-mode-switch button').off('click.ke014').on('click.ke014', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      setSideMode(idx, $(this).data('mode'));
    });

    /* [3] Kopfzeile klappt ihre Seite auf; die andere geht dabei zu. */
    $popup.off('click.ke014Side', '.ke014-side--klappbar > .pattles-message-header')
      .on('click.ke014Side', '.ke014-side--klappbar > .pattles-message-header', function() {
        var $side = $(this).parent();
        if ($side.hasClass('is-side-open')) return;
        var treffer = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
        if (!treffer) return;
        ke014OpenSide(parseInt(treffer[1], 10), true);
      });

    $popup.off('click.ke014Symbol', '.ke014-symbol-grid button').on('click.ke014Symbol', '.ke014-symbol-grid button', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      var symName = $(this).data('symbol');
      if (!symName) return;
      setSymbolSelection(idx, symName);
    });

    $popup.find('.number-header-textarea').off('input.ke014 propertychange.ke014').on('input.ke014 propertychange.ke014', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      var mode = $side.attr('data-ke014-mode') || 'zeichen';

      if (mode === 'zeichen') {
        var text = $input.val() || '';
        var symbol = normalizeKe014StoredSymbol($side.attr('data-ke014-symbol') || '');
        while (weightedLength(composeEngraving(text, symbol)) > CHAR_MAX && text.length) {
          text = text.slice(0, -1);
        }
        $input.val(text);
      } else {
        var val = $input.val() || '';
        while (weightedLength(val) > CHAR_MAX && val.length) {
          val = val.slice(0, -1);
        }
        var parsed = parseEngravingValue(val);
        $side.attr('data-ke014-symbol', normalizeKe014StoredSymbol(parsed.symbol || ''));
        $input.val(val);
        syncSymbolGridSelection(idx);
      }

      updateCharCounter($input, idx);
      window.ke014UpdatePreview();
    });

    $popup.find('.number-header-icon').off('click.ke014').on('click.ke014', function() {
      var $input = $(this).siblings('.number-header-textarea');
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      $side.attr('data-ke014-symbol', '');
      $input.val('');
      updateCharCounter($input, idx);
      syncSymbolGridSelection(idx);
      $(this).css('display', 'none');
      window.ke014UpdatePreview();
    });
  }

  var KE014_KREUZ_SVG =
    '<svg class="ke014-layout-kreuz" viewBox="0 0 100 100" aria-hidden="true">' +
      '<rect class="ke014-kreuz-linie" x="38" y="24" width="16" height="52" rx="8"/>' +
      '<rect class="ke014-kreuz-linie" x="9" y="42" width="82" height="16" rx="8"/>' +
      '<rect class="ke014-kreuz-fuellung" x="39.2" y="25.2" width="13.6" height="49.6" rx="6.8"/>' +
      '<circle class="ke014-kreuz-oese" cx="17" cy="50" r="3.6"/>' +
      '<circle class="ke014-kreuz-oese" cx="83" cy="50" r="3.6"/>' +
    '</svg>';

  function ke014BuildModeSwitch() {
    var herzSym = getSymbolByName('Herz');
    var herzImg = herzSym && herzSym.image
      ? '<img src="' + esc(herzSym.image) + '" alt="Herz">'
      : '&#9825;';

    function karte(mode, ovlClass, ovlHtml, name, sub) {
      return '<button type="button" data-mode="' + mode + '">' +
        '<span class="ke014-layout-icon">' +
          KE014_KREUZ_SVG +
          '<span class="ke014-layout-ovl' + ovlClass + '">' + ovlHtml + '</span>' +
        '</span>' +
        '<span class="ke014-layout-name">' + name + '</span>' +
        '<span class="ke014-layout-sub">' + sub + '</span>' +
      '</button>';
    }

    /* Die data-mode-Werte bleiben exakt die alten (zeichen / symbol) —
       setSideMode, Speicherstand und Bestellausgabe haengen daran. KE014 hat
       KEINEN Modus „Text mit Motiv" (anders als LW101). Getauscht wird nur
       das Aussehen. */
    return '<div class="ke014-mode-switch">' +
        karte('zeichen', '', 'Anna', 'Nur Text', 'z.B. ein Name') +
        karte('symbol', ' ke014-layout-ovl--gross', herzImg, 'Nur Motiv', 'nur ein Symbol') +
      '</div>' +
      '<p class="ke014-side-error">Bitte gib einen Gravurtext ein oder wähle ein Symbol.</p>';
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;

    $side.find('.pattles-tab-header').hide();

    /* Gravurstil-Karten (K530-Form): der Anhaenger als Strichbild, darauf die
       Beispielgravur an derselben waagerechten Position wie in der echten
       Vorschau. Die alten drei Textreiter werden ersetzt — erkennbar daran,
       dass die Karten-Auszeichnung fehlt. */
    if (!$side.find('.ke014-mode-switch .ke014-layout-icon').length) {
      $side.find('.ke014-mode-switch, .ke014-side-error').remove();
      $side.find('.pattles-message-header').after(ke014BuildModeSwitch());
    }

    var $input = $side.find('.text_class_' + sideIndex);
    if (typeof $side.attr('data-ke014-symbol') === 'undefined') {
      var initial = parseEngravingValue($input.val() || '');
      $side.attr('data-ke014-symbol', normalizeKe014StoredSymbol(initial.symbol));
    }
    applyFixedFont($input);
    $input.attr('placeholder', 'Gib deinen Gravurtext ein.');
    $input.attr('maxlength', 40);

    var $words = $side.find('.number-header-words');
    if ($words.length) {
      $words.html('<span class="number-1">0</span> / <span class="wordsNum_v1">' + CHAR_MAX + '</span>');
    }

    setSideMode(sideIndex, sideModes[sideIndex] || 'zeichen');
  }

  /* ==================================================================
     FOKUS — K530-Anzeigestandard (Yin 2026-08-15). Nur Darstellung und
     Bedienung; die Bestell-Eigenschaften bleiben Zeichen fuer Zeichen
     unveraendert.
     ================================================================== */

  function ke014SideEl(index) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
  }

  function ke014AlleSeiten() {
    return $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
  }

  function ke014ScrollEl() {
    return $('.up-Fenster-p-personalization-1')
      .find('.fenster-content-inner, .fenster-content-contentin').get(0);
  }

  function ke014ScrollSideIntoView($side) {
    var scrollEl = ke014ScrollEl();
    if (!scrollEl || !$side || !$side.length) return;
    var top = $side[0].getBoundingClientRect().top
      - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - 8;
    scrollEl.scrollTop = Math.max(0, top);
  }


  /* [3] Seiten-Akkordeon: nur bei beidseitiger Gravur, dann ist immer genau
     eine Seite offen. Der Zustand ueberlebt den Neuaufbau des Popups. */
  var ke014OffeneSeite = 0;

  function ke014EnsureChevron($side) {
    var $head = $side.children('.pattles-message-header');
    /* Der Titel-<span> bleibt das ERSTE Kind — getSideLabel liest ihn per
       .first(), das Chevron haengt dahinter. */
    if ($head.length && !$head.children('.ke014-side-chev').length) {
      $head.append('<span class="ke014-side-chev" aria-hidden="true">▾</span>');
    }
  }

  function ke014OpenSide(index, scrollen) {
    var $sides = ke014AlleSeiten();
    if (!$sides.filter('.ke014-side--klappbar').length) return;
    ke014OffeneSeite = index;
    $sides.removeClass('is-side-open');
    var $ziel = ke014SideEl(index).addClass('is-side-open');
    if (scrollen) ke014ScrollSideIntoView($ziel);
  }

  function ke014ApplyAkkordeon(zu) {
    var $sides = ke014AlleSeiten();
    if (zu < 2) {
      /* Einseitig: kein Akkordeon — die Klasse wegnehmen, damit die
         Zuklapp-Regeln nichts verstecken koennen. */
      $sides.removeClass('ke014-side--klappbar').addClass('is-side-open');
      return;
    }
    $sides.addClass('ke014-side--klappbar').each(function() {
      ke014EnsureChevron($(this));
    });
    var ziel = (ke014OffeneSeite >= 0 && ke014OffeneSeite < zu) ? ke014OffeneSeite : 0;
    $sides.removeClass('is-side-open');
    ke014SideEl(ziel).addClass('is-side-open');
    ke014OffeneSeite = ziel;
  }

  window.ke014ValidateBeforeOpen = function() { return true; };

  window.ke014AfterUpdateSize = function(zu) {
    if (window.ke014GravurConfig && window.ke014GravurConfig.physicalSides) {
      setPhysicalSideMap(window.ke014GravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) {
      return;
    }
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) {
      setupSide(i);
    }
    ke014ApplyAkkordeon(zu);
    bindSideEvents();
    window.ke014UpdatePreview();
  };

  window.ke014OnPopupOpen = function() {
    ke014SymbolsCache = null;
    if (window.ke014RefreshPopupSides) {
      ke014RefreshPopupSides();
    }
    ensurePreviewShell();
    var $sides = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
    previewSideCount = $sides.length || previewSideCount;
    if (window.ke014AfterUpdateSize) {
      ke014AfterUpdateSize(previewSideCount);
    } else {
      bindSideEvents();
      window.ke014UpdatePreview();
    }
  };

  window.ke014OnPopupClose = function() {
    $('.product-info--ke014 [class*="product_info_main_"]').removeClass('has-error');
  };

  window.ke014ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var valid = true;
    var ersteFehlerSeite = -1;
    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      var mode = getSideMode(i);
      $side.removeClass('has-error');
      $side.find('.ke014-side-error').hide();
      $side.find('.text_class_' + i).parent().removeClass('error');

      var engraving = getSideEngraving(i);
      var sideValid = false;
      if (mode === 'symbol_text') {
        sideValid = !!$.trim(engraving.text) && !!engraving.symbol;
      } else {
        sideValid = !!$.trim(getComposedEngraving(i));
      }

      if (!sideValid) {
        valid = false;
        $side.addClass('has-error');
        $side.find('.text_class_' + i).parent().addClass('error');
        $side.find('.ke014-side-error').show();
        if (ersteFehlerSeite < 0) ersteFehlerSeite = i;
      }
    }
    if (!valid) {
      /* [6] Fokus-Regel: nur die ERSTE fehlerhafte Seite aufklappen und
         anspringen. Weitere fehlerhafte Seiten tragen am zugeklappten Kopf
         ein rotes „!" und kommen beim naechsten Klick der Reihe nach dran. */
      if (ersteFehlerSeite >= 0) ke014OpenSide(ersteFehlerSeite, false);
      alert('Bitte fülle die Gravur für jede Seite aus.');
      if (ersteFehlerSeite >= 0) ke014ScrollSideIntoView(ke014SideEl(ersteFehlerSeite));
    }
    return valid;
  };

  window.ke014AppendSideProperties = function(properies_arr, zu, popup_title) {
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      var orderRow = ke014OrderRow(title, engraving, true);
      if ($.trim(orderRow.value)) properies_arr.push([orderRow.name, orderRow.value]);
      if (engraving.text) properies_arr.push([title + ' Font', KE014_FONT.name]);
    }
  };

  window.ke014ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      var confirmRow = ke014OrderRow(title, engraving, false);
      if ($.trim(confirmRow.value)) {
        html += template.replaceAll('{option_name}', confirmRow.name).replaceAll('{option_value}', confirmRow.value);
      }
      if (engraving.text) {
        html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', KE014_FONT.name);
      }
    }
    if (html) {
      /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt wird er per
         DOM-Klon NACH dem Einhaengen der Bestaetigungsseite. */
      html = '<div class="ke014-confirm-vorschau" aria-hidden="true"></div>' + html;
    }
    return html;
  };

  /* [7] Vorschau-Streifen auf der Bestaetigungsseite: klont die live gerenderte
     Buehne aus dem Popup — gleiche Seite, gleiche Styles und Schrift, also
     pixelgleich zum Popup. KE014 hat GENAU EINE Buehne (bei beidseitiger
     Gravur zeigt das Basisbild beide Kreuze uebereinander), also eine Kachel.
     WICHTIG: beim Bestaetigen ist das Popup zu, die Buehne also 0 breit —
     darum vorher unsichtbar messbar machen (fixed, -9999px), frisch rendern,
     klonen, alles zurueckdrehen. */
  function ke014FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .ke014-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;

    var altStyle = $popup.attr('style') || '';
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    window.ke014UpdatePreview();

    var $stage = $('[data-ke014-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      var ZIEL_B = Math.max(64, Math.min(130, $ziel.width() || 320));
      var f = ZIEL_B / sw;
      var $clip = $('<div class="ke014-cv-clip"></div>')
        .css({ width: ZIEL_B + 'px', height: Math.ceil(sh * f) + 'px', overflow: 'hidden' });
      var $scale = $('<div class="ke014-cv-scale"></div>')
        .css({ width: sw + 'px', transform: 'scale(' + f + ')', 'transform-origin': 'top left' });
      $scale.append($stage.clone());
      $clip.append($scale);
      var name = previewSideCount > 1
        ? 'VS · RS'
        : (physicalSideMap[0] === 1 ? 'RS' : 'VS');
      $ziel.append($('<div class="ke014-cv-item"></div>')
        .css('width', ZIEL_B + 'px')
        .append($clip)
        .append('<div class="ke014-cv-name">' + esc(name) + '</div>'));
    }

    $popup.attr('style', altStyle);
  }

  window.ke014EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung. */
    setTimeout(ke014FillConfirmVorschau, 0);
  };




  $(document).on('change.ke014Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.ke014UpdatePreview();
    }
  });

  $(document).on('change.ke014GravurOption', '[name="option2"]', function() {
    window.ke014GravurConfig = null;
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.ke014UpdatePreview();
    }
  });
})(jQuery);
